import type { AuthResponse } from '@/js/types/auth';
import { makeApiRoute, makeRequest } from '@/js/api/request-service';

export async function subscribe(formData: FormData) {
  return makeRequest<AuthResponse>({
    method: 'POST',
    url: makeApiRoute('auth/account/subscribe/update'),
    data: formData,
  });
}

export async function updateProfile(formData: FormData) {
  return makeRequest<AuthResponse>({
    method: 'POST',
    url: makeApiRoute('auth/account/profile/update'),
    data: formData,
  });
}

export async function updatePassword(formData: FormData) {
  return makeRequest<AuthResponse>({
    method: 'POST',
    url: makeApiRoute('auth/account/password/update'),
    data: formData,
  });
}
